import React from 'react';
import './ColumnUser.css';
import UserColumn from './UserColumn.mjs';

export default function ColumnUser() 
{
    return ( <> <UserColumn /> </> );
}